/**
 * Implements a template look up utility
 */

import Marionette from "backbone.marionette";
import templates from "../templates/core";

// eslint-disable-next-line no-unused-vars
import * as Utils from "../utils";

class Templates extends Marionette.Object {
  initialize() {
    // export Utils to window scope.
    // This is necessary until the template system is upgraded...
    window.RVC.Utils = Utils;

    this._created = new Date();
  }

  /**
   * Retrieves the requested template when found, otherwise returns null
   *
   * @param {String} type
   * @param {String} name
   * @returns A compiled {template} or null
   */
  find(type, name) {
    return templates[type] && templates[type][name]
      ? _.template(templates[type][name])
      : null;
  }

  // creates single instance of Environment
  static createInstance() {
    if (!Templates.instance) {
      Templates.instance = new Templates();
    }
    return Templates.instance;
  }
}

// instantiate the singleton
const singleton = Templates.createInstance();

// export the singleton
export { singleton as default };
